import FacebookIcon from './FacebookIcon'
import GithubIcon from './GithubIcon'
import GoogleIcon from './GoogleIcon'
import InstagramIcon from './InstagramIcon'
import LinkedinIcon from './LinkedinIcon'
import TiktokIcon from './TiktokIcon'
import TwitterIcon from './TwitterIcon'
import YoutubeIcon from './YoutubeIcon'

interface Props {
  provider: string
  width: number
  className?: string
}

const SocialIcon = ({ provider, width, className }: Props) => (
  <>
    {provider === 'facebook' && (
      <FacebookIcon width={width} className={className} />
    )}
    {provider === 'linkedin' && (
      <LinkedinIcon width={width} className={className} />
    )}
    {provider === 'instagram' && (
      <InstagramIcon width={width} className={className} />
    )}
    {provider === 'tiktok' && (
      <TiktokIcon width={width} className={className} />
    )}
    {provider === 'youtube' && (
      <YoutubeIcon width={width} className={className} />
    )}
    {provider === 'github' && (
      <GithubIcon width={width} className={className} />
    )}
    {provider === 'twitter' && (
      <TwitterIcon width={width} className={className} />
    )}
    {provider === 'google' && (
      <GoogleIcon width={width} className={className} />
    )}
  </>
)
export default SocialIcon
